var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.84998 30.79999c.25.19.56.27997.87.27997.23004 0 .47003-.04999.68005-.15997.5-.26001.81995-.77997.81995-1.34003v-27.15998c0-.56-.31995-1.08002-.81995-1.34003-.49005-.25-1.10004-.20996-1.55005.12006l-10.56 7.52997h-5.28998c-.83002 0-1.5.67999-1.5 1.5v11.53998c0 .82001.66998 1.5 1.5 1.5h5.28998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.06055 12.05707c-.58594-.58594-1.53516-.58594-2.12109 0l-1.82178 1.82159-1.82178-1.82159c-.58594-.58594-1.53516-.58594-2.12109 0s-.58594 1.53564 0 2.12109l1.82172 1.82153-1.82172 1.82153c-.58594.58594-.58594 1.53516 0 2.12109.29297.29297.67676.43945 1.06055.43945s.76758-.14648 1.06055-.43945l1.82178-1.82159 1.82178 1.82159c.29297.29297.67676.43945 1.06055.43945s.76758-.14648 1.06055-.43945c.58594-.58594.58594-1.53516 0-2.12109l-1.82172-1.82153 1.82172-1.82153c.58591-.58545.58591-1.53515-.00002-2.12109z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundoff);
export default __webpack_public_path__ + "static/media/soundoff.05028a1a97eb86631df65ef8c96b62fe.svg";
export { ForwardRef as ReactComponent };